import { DeliveryNotice } from "../components/DeliveryNotice";
import { Seo } from "../components/Seo";
import { hasText, site } from "../config/site";
import { formatGbp } from "../lib/money";

export function DeliveryPage() {
  const regions = site.delivery.regions.filter((region) => hasText(region.name));
  const policy = site.policies.deliveryAndReturns.trim();
  const hasPublishedDetail = regions.length > 0 || Boolean(policy);

  return (
    <main id="main" className="page">
      <Seo
        title="Delivery and returns"
        description="Delivery and returns for Beautiful Jewellery."
        path="/delivery-and-returns"
      />
      <p className="kicker">Delivery</p>
      <h1>Delivery and returns</h1>
      <DeliveryNotice />
      {hasPublishedDetail ? (
        <>
          {regions.length > 0 ? (
            <section className="section">
              <h2>Charges and regions</h2>
              <table className="basket-table">
                <thead>
                  <tr>
                    <th scope="col">Region</th>
                    <th scope="col">Charge</th>
                    <th scope="col">Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {regions.map((region) => (
                    <tr key={region.id}>
                      <td>{region.name}</td>
                      <td>
                        {region.chargeGbp === null ? "—" : formatGbp(region.chargeGbp)}
                      </td>
                      <td>{hasText(region.notes) ? region.notes : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          ) : null}
          {policy ? (
            <section className="section">
              <h2>Returns</h2>
              <div className="info-card padded-card policy-copy">{policy}</div>
            </section>
          ) : null}
        </>
      ) : (
        <p className="lede">
          Delivery details will be shared when the collection is ready.
        </p>
      )}
    </main>
  );
}
